import React, { useState } from 'react';
import styled from 'styled-components';
import TabSlider from '../../misc/TabSlider';

import ThemeIcons from '../../../theme/Icons';

const StyledTabsWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const StyledTabs = styled.div`
  max-width: 150px;
  margin-bottom: 12px;
`;

const StyledTabWrapper = styled.div`
  opacity: 0;
  height: 0px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;

  &.active {
    opacity: 1;
    height: initial;
  }

`;

const SettingsTabs = ({
  settings,
  styles
}) => {

  const [active, setActive] = useState('settings');

  const tabs = [{ id: 'settings', icon: ThemeIcons.settings.settings }];
  if (styles) tabs.push({ id: 'style', icon: ThemeIcons.settings.styles });

  return (
    <>
      <StyledTabsWrapper>
        <StyledTabs>
          <TabSlider
            tabWidth={60}
            tabHeight={28}
            onChange={setActive}
            tabs={tabs}
          />
        </StyledTabs>
      </StyledTabsWrapper>
      <StyledTabWrapper className={active === 'style' ? 'active' : ''}>
        {styles}
      </StyledTabWrapper>
      <StyledTabWrapper className={active === 'settings' ? 'active' : ''}>
        {settings}
      </StyledTabWrapper>
    </>
  );

};

export default SettingsTabs;
